import React, { Component } from 'react';
import { Card } from '@betareader/design-system';
import { withTranslation } from 'react-i18next';
import { Media } from 'src/utils/Media';

import PricingPlan from './pricingPlan';
import ProductToSMessage from '../../../components/payments/productToSMessage';
import AppIcon from '../../../components/AppIcon';
import './productCard.css';

const appleProductIdForPlan = internalId =>
  ({
    standard_monthly: 'io.betareader.premium.monthly',
    standard_yearly: 'io.betareader.premium.yearly',
    pro_monthly: 'io.betareader.pro.monthly',
    pro_yearly: 'io.betareader.pro.yearly',
  })[internalId];

export class ProductCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      localisedPricing: {},
    };
  }

  componentDidMount() {
    const { product, nativeMode } = this.props;
    if (nativeMode) return;
    const featuresWithPricing = (product.featureDescriptions || []).filter(
      feature => feature.paddleProductId
    );
    if (!featuresWithPricing.length) return;
    this.loadPaddlePricing = () =>
      this.getLocalisedPricing(featuresWithPricing);
    if (window.Paddle?.Product?.Prices) this.loadPaddlePricing();
    else {
      window.addEventListener(
        'betareader:paddle-ready',
        this.loadPaddlePricing
      );
    }
  }

  componentWillUnmount() {
    if (this.loadPaddlePricing) {
      window.removeEventListener(
        'betareader:paddle-ready',
        this.loadPaddlePricing
      );
    }
  }

  getLocalisedPricing = features => {
    if (!window.Paddle?.Product?.Prices) return;
    features.forEach(feature => {
      window.Paddle.Product.Prices(feature.paddleProductId, pricing => {
        this.setState(prevState => {
          const newLocalisedPricing = {
            ...prevState.localisedPricing,
          };
          newLocalisedPricing[feature.paddleProductId] = pricing.price.gross;
          return {
            localisedPricing: newLocalisedPricing,
          };
        });
      });
    });
    window.removeEventListener(
      'betareader:paddle-ready',
      this.loadPaddlePricing
    );
  };

  getPricingPlans = (
    currentProduct,
    currentPricingplanId,
    isCancelled,
    validUntilDate
  ) => {
    const {
      pricingPlans,
      hideButton,
      currentBillingInterval,
      planIntervalFilter,
      isLoggedIn,
      nativeMode,
      nativeProducts = [],
      purchasePendingProductId,
      purchaseInProgress,
    } = this.props;
    const filteredPlanList = pricingPlans.filter(pricingPlan => {
      return (
        pricingPlan.billingInterval === planIntervalFilter ||
        pricingPlan.billingInterval === 'none'
      );
    });
    const pricingPlanList = filteredPlanList.map(pricingPlan => {
      const purchaseProductId = nativeMode
        ? appleProductIdForPlan(pricingPlan.internalId)
        : pricingPlan.externalId;
      return (
        <PricingPlan
          key={pricingPlan._id}
          hideButton={hideButton}
          isCurrentPricingPlan={pricingPlan._id === currentPricingplanId}
          currentBillingInterval={currentBillingInterval}
          pricingPlan={pricingPlan}
          onPress={(selectedPricingPlan, localPriceObject) =>
            this.props.onPress(selectedPricingPlan)
          }
          isCancelled={isCancelled}
          isLoggedIn={isLoggedIn}
          validUntilDate={validUntilDate}
          nativeMode={nativeMode}
          nativePrice={
            nativeProducts.find(
              item =>
                item.productId ===
                appleProductIdForPlan(pricingPlan.internalId)
            )?.priceString
          }
          purchasePending={purchasePendingProductId === purchaseProductId}
          purchaseInProgress={purchaseInProgress}
        />
      );
    });
    return <div>{pricingPlanList}</div>;
  };

  render() {
    const {
      product,
      t,
      currentProduct,
      currentPricingplanId,
      isCancelled,
      validUntilDate,
    } = this.props;
    const { localisedPricing } = this.state;
    const publicProductTitle =
      product.internalId === 'standard' ? 'Premium' : product.title;
    return (
      <Card key={product._id} className={`subscription-product-card${currentProduct ? ' subscription-product-card--current' : ''}`}>
        <div className="subscription-product-card__content">
          <h3 className="subscription-product-card__title">
            {t(publicProductTitle).toUpperCase()}
          </h3>
          <p className="subscription-product-card__description">
            {t(product.description)}
          </p>
          {this.getPricingPlans(
            currentProduct,
            currentPricingplanId,
            isCancelled,
            validUntilDate
          )}
          <hr className="subscription-product-card__divider" />
          <div className="subscription-product-card__features">
            {product.featureDescriptions && (
              <ul>
                {product.featureDescriptions.map(feature => (
                  <li key={feature.name}>
                    <AppIcon name="check" aria-hidden="true" />
                    <span>
                      {feature.included && (
                        <strong>
                          {t(feature.name)}
                          {!!feature.paddleProductId &&
                            localisedPricing[feature.paddleProductId] && (
                              <span style={{ marginLeft: '1em' }}>
                                {localisedPricing[feature.paddleProductId]}{' '}
                                {t('PerMonth')}
                              </span>
                            )}
                        </strong>
                      )}
                      {!feature.included && <em>{t(feature.name)}</em>}
                    </span>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
        <Media at="tablet">
          {(className, renderChildren) =>
            renderChildren && (
              <div className="subscription-product-card__terms">
                <ProductToSMessage className="product-card-tos-message" />
              </div>
            )
          }
        </Media>
      </Card>
    );
  }
}

export default withTranslation()(ProductCard);
